<script>
  export let headerName;
  export let width = 310;


</script>

<div class="column" style={`width: ${width}px`}>
  <div class="column-header">{headerName}</div>
  <div class="column-contents">
    <slot></slot>
  </div>
  <svg class="column-footer" viewBox={`0 0 ${width} 30`} xmlns="http://www.w3.org/2000/svg">
    <path d={`M${width} 0H0L30 30H${width-30}L${width} 0Z`} fill="#101010" fill-opacity="0.75"/>
  </svg>
</div>

<style>
  .column-header {
    background-color: rgba(156, 44, 44, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.1em 0;
    height: 43px;
  }

  .column-contents {
    height: 793px;
    background: rgba(16, 16, 16, 0.75);
    margin-bottom: 3px;
  }

  .column {
    /* width: 310px; */
    margin-right: 1em;
  }
</style>